import styled, { css } from 'styled-components';

import { FilterType } from './button';

export const FiltersContainer = styled.div`
  display: flex;
  width: 259px;
  height: 100%;
  box-sizing: border-box;
  padding: var(--sizes-60) 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  background: var(--color-grayscale-white);
  border-right: 1px solid var(--color-gray-20);
  flex-shrink: 0;
`;

export const FilterContainerTitle = styled.span`
  font: var(--font-large-16pt-semibold);
  padding-left: var(--sizes-50);
`;

export const FilterButtonListContainer = styled.ul`
  list-style: none;
  width: 100%;
  overflow: auto;
`;

export const StyledFilterButtonListItem = styled.li`
  border-bottom: 1px solid var(--color-gray-20);
  &&:last-of-type {
    border-bottom: none;
  }
`;

export const StyledFilterButton = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: var(--color-grayscale-white);
  &:hover {
    background: var(--color-gray-10);
  }
  display: flex;
  padding: var(--sizes-30) var(--sizes-50);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sizes-20);
  align-self: stretch;
  cursor: pointer;
`;

export const ButtonTitle = styled.span`
  font: var(--font-small-13pt-semibold);
  color: var(--color-grayscale-black);
`;

export const StyledFilterList = styled.p`
  text-align: left;
  font: var(--font-extra-small-12pt-normal);
  color: var(--color-gray-90);
  line-height: 18px;
  min-height: 18px;
`;

const NoFilterStyles = css`
  border-color: var(--color-gray-20);
  background: var(--color-gray-20);
  color: var(--color-gray-90);
`;

const InclusionaryFilterStyles = css`
  border-color: var(--color-green-60);
  background: var(--color-green-10);
  color: var(--color-green-70);
`;

const ExclusionaryFilterStyles = css`
  border-color: var(--color-red-40);
  background: var(--color-red-10);
  color: var(--color-red-60);
`;

export const StyledFilterTypeBadge = styled.span<{ $type: FilterType }>`
  font: var(--font-micro-10pt-bold);
  font-size: 9px;
  letter-spacing: 0.045px;
  text-transform: uppercase;
  line-height: 14px;
  border-radius: 2px;
  border: 1px solid;
  padding: 2px 4px;
  margin-right: 4px;
  ${({ $type }) => $type === FilterType.NONE && NoFilterStyles}
  ${({ $type }) => $type === FilterType.INCLUSIONARY && InclusionaryFilterStyles}
  ${({ $type }) => $type === FilterType.EXCLUSIONARY && ExclusionaryFilterStyles}
`;

export const TooltipIndicatorText = styled.span`
  border-bottom: 1px dashed var(--color-gray-90);
`;

export const TooltipContents = styled.p`
  width: 176px;
  max-height: 300px;
  overflow: auto;
`;
